import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  max-height: ${props => (props.carbonOffset ? '470px' : '312px')};
  margin-top: ${props => props.theme.spacing.sp8};
  overflow-x: hidden;
  overflow-y: auto;
`

export const TabsContainer = styled.div`
  background-color: ${props => props.theme.colors.background.secondary};
  height: 2rem;

  && .MuiTabs-root {
    min-height: 2rem;
  }

  && .MuiTab-root {
    min-height: 2rem;
    height: 2rem;
  }

  && .MuiTabs-indicator {
    bottom: 0;
  }
`

export const TabLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
